// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LGJ8","newExpiryDate":"styles_newExpiryDate__2gCTk","footer":"styles_footer__1UHue"};